import React from 'react';
import {Tooltip} from '@material-ui/core';
import {QRCode} from 'react-qrcode-logo';
import Logo from 'assets/images/logo.png';
import AuthenticatedUserService from 'services/AuthenticatedUserService';

import './QRCodeToolTip.scss';

/* ---------- props ---------- */
interface QrCodeToolTipProps {
  /** The element that triggers the tooltip (e.g., round IconButton) */
  children: React.ReactElement;
  /** Full invite URL to encode */
  url: string;
  /** Raw invite code to display underneath */
  inviteCode: string;
}

const QrCodeToolTip: React.FC<QrCodeToolTipProps> = ({
  children,
  url,
  inviteCode,
}) => {
  const supplierName = AuthenticatedUserService.getUserFullName();
  const companyName = AuthenticatedUserService.getCompany()?.name;
  const qrSize = 250;

  return (
    <Tooltip
      interactive
      placement="bottom"
      /* custom bubble style */
      classes={{tooltip: 'qr-tooltip-body'}}
      title={
        <div id="qrCard" className="qr-card">
          <span className="qr-supplier">{supplierName}</span>
          {companyName && <span className="qr-company">({companyName})</span>}

          <QRCode
            value={url}
            size={qrSize}
            qrStyle="dots"
            eyeRadius={5}
            fgColor="#043333"
            logoImage={Logo}
            logoWidth={qrSize * 0.2}
            logoHeight={qrSize * 0.2}
          />

          <span className="qr-code-label">code:</span>
          <span className="qr-invite">{inviteCode.toUpperCase()}</span>
        </div>
      }
    >
      {children}
    </Tooltip>
  );
};

export default QrCodeToolTip;
